import BaseStyle from '@primevue/core/base/style';

const classes = {
    root: 'p-fluid'
};

export default BaseStyle.extend({
    name: 'fluid',
    classes
});
